import React from 'react';
import {Link} from "react-router-dom";

import classNames from 'classnames'

import './index.scss';

const Navigation = (props) => {

  const {className, prevLink, nextLink, handlePrev, handleNext, nextText, history} = props;

  // console.log(props);

  return (
    <div className={classNames('navigation', className)}>

      <Link
        to={{
          pathname: prevLink,
          state: {
            prev: history.location.pathname
          }
        }}
        className="navigation__item  navigation__item--prev"
        onClick={handlePrev}>
        &lt; Zurück
      </Link>

      <Link
        to={{
          pathname: nextLink,
          state: {
            prev: history.location.pathname
          }
        }}
        className="navigation__item navigation__item--next"
        onClick={handleNext}
      >
        {nextText} &gt;
      </Link>

    </div>
  );

};

export default Navigation;

